import * as React from "react"
import { Checkbox, Message } from "semantic-ui-react"
import ButtonLock from "../buttons/com_button-lock"
import { convertToBoolean, isError } from "../../../utils"
import { IFormFieldProps } from "."
import ButtonChange from "../buttons/com_button-change"
import { permanentFormIds } from "../../../models"
import { PreviousValueMessage } from "./form-field-tools"

class CheckBox extends React.Component<IFormFieldProps<boolean>, any> {
  public shouldComponentUpdate(nextProps: IFormFieldProps<boolean>) {
    return (
      this.props.data.value !== nextProps.data.value ||
      this.props.data.lock !== nextProps.data.lock ||
      this.props.data.errorText !== nextProps.data.errorText ||
      this.props.label !== nextProps.label ||
      this.props.disabled !== nextProps.disabled ||
      this.props.oldValue !== nextProps.oldValue
    )
  }

  public render() {
    const {
      label = "",
      onChange,
      data,
      isNewProduct,
      onLockClick,
      disabled,
      checkboxProps,
      formId,
      onModifyClick,
      oldValue,
      ...props
    } = this.props

    const { code, lock, errorText, value, isRequired, fieldType } = data
    const { checkboxStyle } = checkboxProps || { checkboxStyle: "" }

    const handleChange = (event: any, newValue: any) => {
      onChange({ code, fieldValue: newValue.checked, lock, fieldType })
    }

    return (
      <div key={code} className="lock-div" style={props.style?.lockDiv}>
        {oldValue &&
        convertToBoolean(oldValue.isEmpty ? false : oldValue.value) !==
          convertToBoolean(value) ? (
          <PreviousValueMessage
            label={oldValue.formattedDate}
            content={
              <Checkbox
                toggle={checkboxStyle === "toggle"}
                slider={checkboxStyle === "slider"}
                checked={
                  convertToBoolean(
                    oldValue.isEmpty ? false : oldValue.value
                  ).toString() === "true"
                }
                type="checkbox"
              />
            }
          />
        ) : (
          ""
        )}
        {isError(errorText) ? (
          <Message
            className="error-field-message"
            negative
            header={errorText}
          />
        ) : (
          ""
        )}
        <div
          className={"text-field " + (errorText ? "error-field" : "")}
          style={props.style?.textField}
        >
          <Checkbox
            label={label + (isRequired ? "*" : "")}
            toggle={checkboxStyle === "toggle"}
            slider={checkboxStyle === "slider"}
            name={code}
            checked={value.toString() === "true"}
            onChange={handleChange}
            disabled={disabled}
            className="field-checkbox"
            {...props}
            type="checkbox"
          />
          {formId === permanentFormIds.MULTI_MODIF && onModifyClick ? (
            <ButtonChange
              modified={data.modified}
              onClick={onModifyClick}
              code={code}
              fieldType={fieldType}
            />
          ) : (
            <ButtonLock
              hidden={!isNewProduct}
              lockable={props.lockable}
              onClick={onLockClick}
              code={code}
              lock={lock}
              fieldType={fieldType}
            />
          )}
        </div>
      </div>
    )
  }
}

export default CheckBox
